// Fonte: UManutContas.pas — AtualizaFornecedor() ~linha 11647
// Propaga alterações do fornecedor para outros GEs com mesmo CNPJ
import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { listarFornecedoresMesmoCnpj, propagarFornecedor } from '~/Services/Service';

var ModalPropagarFornecedor = function(_ref) {
  var show = _ref.show;
  var ge = _ref.ge;
  var codigo = _ref.codigo;
  var onHide = _ref.onHide;
  var onConcluido = _ref.onConcluido;

  var [fornecedores, setFornecedores] = useState([]);
  var [selecionados, setSelecionados] = useState([]);
  var [loading, setLoading] = useState(false);
  var [propagando, setPropagando] = useState(false);

  useEffect(function() {
    if (show && ge && codigo) {
      setLoading(true);
      listarFornecedoresMesmoCnpj(ge, codigo)
        .then(function(resp) {
          var lista = Array.isArray(resp) ? resp : [];
          setFornecedores(lista);
          setSelecionados(lista.map(function(f) { return f.codigo_grupo_empresa; }));
        })
        .catch(function() {
          toast.error('Erro ao buscar fornecedores cross-GE');
        })
        .finally(function() { setLoading(false); });
    }
  }, [show, ge, codigo]);

  var toggleSelecionado = function(geItem) {
    setSelecionados(function(prev) {
      if (prev.includes(geItem)) {
        return prev.filter(function(g) { return g !== geItem; });
      }
      return prev.concat([geItem]);
    });
  };

  var handlePropagar = function() {
    if (selecionados.length === 0) {
      toast.warning('Selecione ao menos um GE para propagar');
      return;
    }
    setPropagando(true);
    propagarFornecedor({
      ge_origem: ge,
      codigo_conta: codigo,
      ges_destino: selecionados,
    })
      .then(function() {
        toast.success('Fornecedor propagado com sucesso!');
        if (onConcluido) onConcluido();
        onHide();
      })
      .catch(function() {
        toast.error('Erro ao propagar fornecedor');
      })
      .finally(function() { setPropagando(false); });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className="contas-modal-header">
        <Modal.Title>Propagar Dados do Fornecedor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          Os GEs abaixo possuem o mesmo CNPJ. Selecione os que deseja atualizar com os dados atuais do fornecedor.
        </p>
        {loading ? (
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : fornecedores.length === 0 ? (
          <p className="text-muted text-center">Nenhum outro GE com o mesmo CNPJ encontrado.</p>
        ) : (
          <Table size="sm" bordered>
            <thead>
              <tr>
                <th style={{ width: 50 }}></th>
                <th>GE</th>
                <th>Conta</th>
                <th>Apelido</th>
              </tr>
            </thead>
            <tbody>
              {fornecedores.map(function(f) {
                return (
                  <tr key={f.codigo_grupo_empresa}>
                    <td className="text-center">
                      <Form.Check
                        type="checkbox"
                        checked={selecionados.includes(f.codigo_grupo_empresa)}
                        onChange={function() { toggleSelecionado(f.codigo_grupo_empresa); }}
                      />
                    </td>
                    <td>{f.codigo_grupo_empresa}</td>
                    <td>{f.codigo_conta}</td>
                    <td>{f.apelido_conta}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={propagando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handlePropagar} disabled={propagando || loading}>
          {propagando ? <Spinner animation="border" size="sm" /> : 'Propagar Selecionados'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPropagarFornecedor;
